var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActionErrorContentLoadingFailed = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20.75a8.75 8.75 0 0016.25 4.51v4.24h1.25v-6.25h-6.25v1.25h3.997a7.5 7.5 0 01-13.997-3.75H12zM18.25 18.25V17h-3.997a7.5 7.5 0 0113.997 3.75h1.25a8.75 8.75 0 00-16.25-4.51V12H12v6.25h6.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 21c0 11.598-9.402 21-21 21S0 32.598 0 21 9.402 0 21 0s21 9.402 21 21zm-2 0c0 10.493-8.507 19-19 19S2 31.493 2 21 10.507 2 21 2s19 8.507 19 19z"
  })));
});
export default SvgActionErrorContentLoadingFailed;